<div>
  <div class="cooking-story-header" [ngClass]="{ shadow: shadowNav }">
    <img
      (click)="goBak()"
      src="assets/cookingbook/angle-white.svg"
      class="goback icon-shadow"
      alt=""
    />
    <p class="title">لیست مورد علاقه</p>
  </div>
  <div>
    <div
      *ngIf="ready"
      class="cooking-story-body"
      (scroll)="scrolling($event)"
      #scroolEl
    >
      <div
        *ngFor="let bookmark of bookmarks"
        (click)="openRecipe(bookmark.recipe._id)"
        class="recipe-item"
      >
        <div
          class="recipe-box recipe-shadow"
          [ngStyle]="{
            'background-image': 'url(' + bookmark?.recipe.image + ')',
            'background-position': 'center center',
            'background-repeat': 'no-repeat'
          }"
        >
          <div class="label">
            <P class="pl-5">
              {{ bookmark.recipe?.impressions }}
            </P>
            <img src="assets/cookingbook/golden-like.svg" alt="" />
          </div>
          <img
            class="play-icon"
            *ngIf="bookmark.recipe?.video"
            src="assets/cookingbook/play.svg"
            alt=""
          />
        </div>
        <p class="recipe-name">
          {{ bookmark.recipe?.food.name }}
        </p>
      </div>
    </div>

    <div *ngIf="!ready" class="cooking-story-body">
      <div class="loading-holder" *ngFor="let i of garr(10)">
        <ngx-skeleton-loader
          animation="pulse"
          class="text-loader"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          animation="pulse"
          class="text-loader2"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            margin: 'auto',
            height: '148px',
            background: 'rgb(216, 216, 216)',
            'border-radius': '24px'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
